/**
 * Tab indices determine what is selected first when tabbing through a page
 * Accesibility recommend top left to right and down.
 * These indices achieve this
 */

/**
 * The Tab Theory.
 *
 * We want the tabbing logic to focus on the first item with lowest index.
 *
 * As items layer we should look for the new first item
 *
 * Order of item layer
 * - Reg Form
 * - Location Selector
 * - Prompts
 * - Video UI
 * - Main Experiencce
 *
 */

/**
 * Our bases enforce a reverse order of the above in terms of tabbing
 * All items with each possible view should then BASE+Order
 */
// const BASE_TAB_INDEX_REGISTRATION_FROM  = 0; //use in reg.
const BASE_TAB_INDEX_LOCATION_SELECTOR = 200
const BASE_TAB_INDEX_PROMPT = 300
const BASE_TAB_INDEX_VIDEO_UI = 400
const BASE_TAB_INDEX_TOUR_SELECTOR = 500
const BASE_TAB_INDEX_MAIN_UI = 600

/**
 * ADA First items
 */
export const REGISTRATION_HIDDEN_FIELD_INDEX = BASE_TAB_INDEX_MAIN_UI + 10
export const SELECTOR_LOCATION_TITLE_INDEX = BASE_TAB_INDEX_TOUR_SELECTOR + 1
export const MAIN_LOCATION_TITLE_INDEX = BASE_TAB_INDEX_MAIN_UI + 12

/* Location Indices */
export const MAIN_LOCATION_BUTTON_INDEX = BASE_TAB_INDEX_LOCATION_SELECTOR + 1

export const SELECTOR_LOCATION_LINK_INDEX = BASE_TAB_INDEX_TOUR_SELECTOR + 2
export const SELECTOR_LOCATION_CLOSE_BUTTON_INDEX = BASE_TAB_INDEX_TOUR_SELECTOR + 3

/* Action Button indices */
export const MAIN_ACTION_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 20
export const PROMPT_ACTION_BUTTON_INDEX = BASE_TAB_INDEX_PROMPT + 20

/* Hover Close Button */
export const MAIN_HOVER_CLOSE_INDEX = BASE_TAB_INDEX_MAIN_UI + 31

/**
 * MAIN Sdcreen
 */
export const MAIN_ACCESS_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 40

/* Description Buttons (info, fullscreen) */
export const MAIN_INFO_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 41
export const MAIN_AUDIO_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 42
export const MAIN_LANGUAGE_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 43
export const MAIN_DESCRIPTION_BOX_INDEX = BASE_TAB_INDEX_MAIN_UI + 44
export const MAIN_TOUR_LANGUAGE_INDEX = BASE_TAB_INDEX_MAIN_UI + 45
// export const MAIN_TOUR_LANGUAGE_BOX_INDEX         = BASE_TAB_INDEX_MAIN_UI + 46
export const MAIN_SHARE_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 47
export const MENU_SHARE_MENU_INDEX = BASE_TAB_INDEX_MAIN_UI + 48

export const MENU_OVERFLOW_MENU_INDEX = BASE_TAB_INDEX_MAIN_UI + 49
export const MAIN_FULL_SCREEN_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 50
/* VR Button */
export const MAIN_VR_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 51
export const MAIN_VR_INSTR_PANEL_ITEM = BASE_TAB_INDEX_MAIN_UI + 52

/* Nav: Stop next button */
export const MAIN_NAV_NEXT_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 53

/* Main Navigation Arrows */
export const MAIN_NAV_BUTTON_INDEX = BASE_TAB_INDEX_MAIN_UI + 54 // for nav arrow tabs

/* Maps */
export const MAIN_MAP_INDEX = -1 // disable the tabbing into map

/* Scene List */
export const MAIN_SCENE_ACTIVATION_ZONE_INDEX = BASE_TAB_INDEX_MAIN_UI + 60
export const MAIN_SCENE_ITEM_INDEX = BASE_TAB_INDEX_MAIN_UI + 61

/* Supplemental: button  */
export const MAIN_SUPPLEMENTAL_MEDIA_BUTTON = BASE_TAB_INDEX_MAIN_UI + 70

/* Video UI */
export const VIDEO_PLAY_BUTTON_INDEX = BASE_TAB_INDEX_VIDEO_UI + 1
export const VIDEO_QUALITY_BUTTON_INDEX = BASE_TAB_INDEX_VIDEO_UI + 2
export const VIDEO_VOLUME_BUTTON_INDEX = BASE_TAB_INDEX_VIDEO_UI + 3
export const VIDEO_SKIP_INDEX = BASE_TAB_INDEX_VIDEO_UI + 4
